export const AUTH_INITIALIZED = "AUTH_INITIALIZED";
export const AUTH_INIT_SAGA = "AUTH_INIT_SAGA";
export const AUTH_STORE_KEY_SAGA = "AUTH_STORE_KEY_SAGA";
export const AUTH_KEY_STORED = "AUTH_KEY_STORED";
export const AUTH_SAGA = "AUTH_SAGA";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILED = "AUTH_FAILED";
export const AUTH_FAILED_SAGA = "AUTH_FAILED_SAGA";
export const AUTH_SUCCESS_SAGA = "AUTH_SUCCESS_SAGA";
export const AUTH_LOCALSTORAGE_KEY = "auth";
export const AUTH_WITH_CREDENTIALS_SAGA = "AUTH_WITH_CREDENTIALS_SAGA";
export const AUTH_ERROR_INVALID_CREDENTIALS = "auth_error_invalid_credentials";
export const AUTH_ERROR = "auth_error";
export const AUTH_LOGOUT_SAGA = "AUTH_LOGOUT_SAGA";
export const AUTH_LOGGED_OUT = "AUTH_LOGGED_OUT";
export const AUTH_UPDATE_TABLE_DEFINITION_SAGA =
    "AUTH_UPDATE_TABLE_DEFINITION_SAGA";
export const AUTH_SET_TABLE_DEFINITION_SAGA = "AUTH_SET_TABLE_DEFINITION_SAGA";
export const AUTH_SET_TABLE_DEFINITION = "AUTH_SET_TABLE_DEFINITION";
export const AUTH_RELOAD_VIEWER = "AUTH_RELOAD_VIEWER";
